import React from 'react';
import $ from 'jquery';
// import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

// import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useDispatch, useSelector } from 'react-redux';

// import 'bootstrap/dist/css/bootstrap.css';
// import Spinner from 'react-bootstrap/Spinner';

import ImageGallery from 'react-image-gallery';
// import {
// 	UpdateGarageListing,
// 	AddMedia,
// 	getGarageCarBrand,
// } from './../../../../Redux/Actions/UserAction';

const images = [
	{
		original: 'assets/images/user/car-dealers/a.jpg',
		thumbnail: 'assets/images/user/car-dealers/a.jpg',
	},
	{
		original: 'assets/images/user/car-dealers/b.jpg',
		thumbnail: 'assets/images/user/car-dealers/b.jpg',
	},
	{
		original: 'assets/images/user/car-dealers/c.jpg',
		thumbnail: 'assets/images/user/car-dealers/c.jpg',
	},
	{
		original: 'assets/images/user/car-dealers/d.jpg',
		thumbnail: 'assets/images/user/car-dealers/d.jpg',
	},
];
export default function CarDealersCarsPost(props) {
	const home = useSelector(state => state?.home);
	const mediaId = home?.AddMediaList?.data?.response?.media;
	// const CarDetail = props;
	console.log('this is the param data ', props);
	useEffect(() => {}, [mediaId]);

	return (
		<>
			<div class='main-content-area '>
				<div class='container'>
					<p class='mb-5 text-center'>
						<a class='btn btn-warning btn-lg' href='#' role='button'>
							<i class='fas fa-paper-plane'></i> POST
						</a>
					</p>

					<div class='row mb-5'>
						<div class='col-12 col-sm-12 col-md-7 col-lg-7 mb-2 mb-sm-2 mb-md-2 mb-lg-0'>
							<div class='bxslider'>
								<ImageGallery items={images} class='img-fluid' />
								{/* <div><img src="assets/images/user/car-dealers/a.jpg" alt="" class="img-fluid" /></div>
                                <div><img src="assets/images/user/car-dealers/b.jpg" alt="" class="img-fluid" /></div>
                                <div><img src="assets/images/user/car-dealers/c.jpg" alt="" class="img-fluid" /></div>
                                <div><img src="assets/images/user/car-dealers/d.jpg" alt="" class="img-fluid" /></div> */}
							</div>
						</div>
						<div class='col-12 col-sm-12 col-md-5 col-lg-5 d-flex align-items-end'>
							<div class='w-100'>
								<p>
									<small>
										<i class='far fa-calendar-alt'></i> Posted Yesterday
									</small>
								</p>

								<h3 class='mb-0'>Lamborghini</h3>
								<p>Aventador</p>

								<p>
									We are an innovative mobile auto service that is the ideal way
									to save your time on all of your tire maintenance needs,. From
									tire changeovers for small cars to SUV, to Oil Filter Change,
									Battery & Brake trimming. Garage has got you covered.
								</p>

								<div class='car-details-block'>
									<div class='row'>
										<div class='col-12'>
											<div class='car-details-block-horizontal'>
												<div class='row'>
													<div class='col-3'>
														<div class='line-a'>Year</div>
														<div class='line-b'>2015</div>
													</div>
													<div class='col-3'>
														<div class='line-a'>Color</div>
														<div class='line-b'>Black</div>
													</div>
													<div class='col-3'>
														<div class='line-a'>Km</div>
														<div class='line-b'>15,00000</div>
													</div>
													<div class='col-3'>
														<div class='line-a'>Cyllnder</div>
														<div class='line-b'>6</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class='car-agent-cwm'>
									<div class='row'>
										<div class='col-4'>
											<a
												class='btn btn-outline-secondary btn-block'
												href='#'
												role='button'>
												<img
													src='assets/images/icons/user/car-dealers/telephone.svg'
													alt=''
													class='icon-cwm'
												/>{' '}
												Call
											</a>
										</div>

										<div class='col-4'>
											<a
												class='btn btn-outline-secondary btn-block'
												href='#'
												role='button'>
												<img
													src='assets/images/icons/user/car-dealers/whatsapp.svg'
													alt=''
													class='icon-cwm'
												/>{' '}
												Whatsapp
											</a>
										</div>

										<div class='col-4'>
											<a
												class='btn btn-outline-secondary btn-block'
												href='#'
												role='button'>
												<img
													src='assets/images/icons/user/car-dealers/map.svg'
													alt=''
													class='icon-cwm'
												/>{' '}
												5 KM
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<h3>Description</h3>
					<p>
						We are an innovative mobile auto service that is the ideal way to
						save your time on all of your tire maintenance needs,. From tire
						changeovers for small cars to SUV, to Oil Filter Change, Battery &
						Brake trimming. Garage has got you covered.
					</p>

					<h3>Specifications</h3>

					<table class='table table-bordered table-striped'>
						<thead>
							<tr>
								<td scope='col'>Interior Color</td>
								<td scope='col'>Black</td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td scope='row'>Seats</td>
								<td>5</td>
							</tr>
							<tr>
								<td scope='row'>Seat Material</td>
								<td>Leather</td>
							</tr>
							<tr>
								<td scope='row'>AC Condition</td>
								<td>Good</td>
							</tr>
							<tr>
								<td scope='row'>Max. Power</td>
								<td>640 CV @ 8.000 rpm</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</>
	);
}
